/*
 *   File : user-detail.js
 *   Author URI : https://evoqins.com
 *   Description : User detail page
 *   Integrations : null
 *   Version : v1.1
 */

/* import packages */
import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/* import components */
import { NavigationHeader } from "../../Components/Header";
import { GradientButton, OutlineButton } from "../../Components/Cta";
import { ConfirmDeleteModal } from "../../Components/Modal";
import { Icon } from "../../Components/Icon";

/* import container */
import { CustomLoader } from "../../Components/Other";
import { Modal } from "bootstrap";
import APIService from "../../Services/api-service";
import { toast } from "react-toastify";

/* import styles */


const WhiteLabelSettingsDetail = React.memo(() => {

    const navigate = useNavigate();
    const { state } = useLocation();
    console.log('detail_state', state);


    const [loader, setLoader] = useState(true);
    const [tabData, setTabData] = useState([]);
    const [initialRender, setInitialRender] = useState(true);
    const [deleteDistributorModal, setDeleteDistributorModal] = useState(false);
    const [distributorData, setDistributorData] = useState({});

    console.log('distributorData', distributorData);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'auto' // Use 'auto' for instant scroll
        });
    }, []);

    useEffect(() => {
        if (initialRender === true)
            setInitialRender(false)
    }, [])

    useEffect(() => {
        _getWhiteLabelDetail();
    }, []);


    useEffect(() => {
        return () => {
            setTabData([]);
        };
    }, []);


    useEffect(() => {
        if (deleteDistributorModal === true) {
            const delete_distributor_modal = new Modal(document.getElementById('confirm-delete-modal'));
            delete_distributor_modal.show();
        }
    }, [deleteDistributorModal]);


    const _handleBack = () => {
        navigate('/white-label-settings');
    };

    const _handleEdit = () => {

        navigate('/white-label-settings/create-list', {
            state: {
                details: distributorData
            }
        });
    };

    const _handleDeleteDistributor = () => {
        setDeleteDistributorModal(true);
    };


    const _getWhiteLabelDetail = () => {
        setLoader(true);
        const is_post = true;
        const url = 'white-label/get-distributor';
        const payload = {
            "id": state.detail_id
        }
        APIService(is_post, url, payload).then((response) => {
            if (response.status_code === 200) {
                setDistributorData(response.data);
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
            setLoader(false);
        })
    };

    const _deleteDistributor = () => {
        const is_post = true;
        const url = 'white-label/toggle-status';
        const payload = {
            "id": state.detail_id ? state.detail_id : distributorData.id
        }
        APIService(is_post, url, payload).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success(response.message);
                navigate('/white-label-settings');
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
        })
    };

    return (
        <Fragment>
            <NavigationHeader
                title="White Label Settings" />
            {
                loader ?
                    <div className="row h-80vh">
                        <CustomLoader />
                    </div>
                    :
                    <div className="ps-4 pe-lg-5 pe-md-2 pe-2 padding-42px-top">

                        <h3 className="mb-0 e-poppins-medium e-font-16 line-height-16px color-light-black padding-24px-bottom">{distributorData.distributor_name}</h3>
                        <div className="row">
                            <div className="col-12">

                                <div className="border-radius-24px p-3 bg-light-grayish-white border-all border-bright-gray">
                                    <div className="row">
                                        <div className="col-md-4 ">
                                            <div className="d-flex align-items-center">
                                                <div className="  d-flex justify-content-center align-items-center  ">
                                                    <img src={distributorData.branding_assets.header_logo_url} width={100} height={100} alt="" className="rounded-circle border-platinum border-all" />
                                                </div>
                                                <div className="ps-4 w-100">
                                                    <h6 className="color-jett-black e-font-16 e-poppins-medium line-height-24px mb-2">
                                                        {distributorData.distributor_name}
                                                    </h6>

                                                    <p className="e-font-14 padding-14px-bottom e-poppins-medium line-height-14px color-gray my-0">
                                                        URL:
                                                        <span className="color-charleston-green-light ps-2">
                                                            {distributorData.domain_url}
                                                        </span>
                                                    </p>

                                                    <p className="e-font-14 e-poppins-medium line-height-14px color-gray my-0">
                                                        Contact no:
                                                        <span className="color-charleston-green-light ps-2">
                                                            {distributorData.phone}
                                                        </span>
                                                    </p>

                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-4 d-flex align-items-center justify-content-center ">
                                            <div className=" ">

                                                <p className="e-font-14 padding-14px-bottom e-poppins-medium line-height-14px color-gray my-0">
                                                    Created on:
                                                    <span className="color-charleston-green-light ps-2">
                                                        {distributorData.created_on}
                                                    </span>
                                                </p>

                                                <p className="e-font-14 e-poppins-medium line-height-14px color-gray my-0">
                                                    Registered email:
                                                    <span className="color-charleston-green-light ps-2">
                                                        {distributorData.email}
                                                    </span>
                                                </p>

                                            </div>
                                        </div>

                                        <div className="col-md-4 d-flex align-items-end justify-content-end ">
                                            <OutlineButton label={distributorData.status ? 'Deactivate Distributor' : "Activate Distributor"}
                                                onPress={_handleDeleteDistributor}
                                                className={`${distributorData.status ? 'color-red border-red' : 'color-primary-color border-primary-color'} me-3  bg-transparent`} />
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>



                        <Fragment>
                            <div className="row padding-24px-top">
                                <div className="col-12">
                                    <div className="border-all border-bright-gray padding-24px-all border-radius-16px">
                                        <h5 className="mb-0 e-poppins-medium e-font-16 line-height-16px color-light-black ">
                                            Branding assets

                                        </h5>
                                        <div className="row padding-24px-top">
                                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-3 pb-4">
                                                <p className="e-font-14 e-poppins-medium  color-light-black mb-2">
                                                    Header logo
                                                </p>
                                                <img src={distributorData.branding_assets.header_logo_url} height={64} width={80} alt="" className="object-fit-cover " />
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-3 pb-4">
                                                <p className="e-font-14 e-poppins-medium  color-light-black mb-2">
                                                    Header logo (dark)
                                                </p>
                                                <img src={distributorData.branding_assets.dark_header_logo} height={64} width={80} alt="" className="object-fit-cover " />
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-3 pb-4">
                                                <p className="e-font-14 e-poppins-medium mb-2 color-light-black ">
                                                    Footer logo
                                                </p>
                                                <img src={distributorData.branding_assets.footer_logo_url} height={64} width={80} className="object-fit-cover " alt="" />
                                                <p className="e-font-8 mt-2 e-poppins-medium  color-light-black mb-0">{distributorData.branding_assets.footer_logo_text}</p>
                                            </div>

                                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-3 pb-4">
                                                <p className="e-font-14 e-poppins-medium mb-2 color-light-black ">
                                                    Footer logo (dark)
                                                </p>
                                                <img src={distributorData.branding_assets.dark_footer_logo} height={64} width={80} className="object-fit-cover " alt="" />
                                                <p className="e-font-8 mt-2 e-poppins-medium  color-light-black mb-0">{distributorData.branding_assets.footer_logo_text}</p>
                                            </div>

                                            <div className="col-lg-8 col-md-4">
                                                <div className=" d-flex justify-content-end cursor-pointer" onClick={_handleEdit}>
                                                    <span className="color-primary-color e-font-16 e-poppins-medium line-height-16px pt-1 pe-1">
                                                        Edit details
                                                    </span>
                                                    <Icon icon='Pen-square'
                                                        size={24} />
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>


                            <div className="row gx-0 padding-28px-top">

                                <div className="col-4  ">
                                    <GradientButton label={"Go back"}
                                        onPress={_handleBack}
                                        className=" padding-60px-lr padding" />

                                </div>

                            </div>
                        </Fragment>

                    </div>
            }

            {
                deleteDistributorModal === true &&
                <ConfirmDeleteModal
                    status={distributorData.status}
                    icon={distributorData.status ? 'deactivate' : 'reactivate'}
                    btnLabel={distributorData.status ? 'Yes, Deactivate' : 'Yes, Activate'}
                    content={distributorData.status ? 'Are you sure you want to deactivate this distributor? Deactivating will remove their access to assigned features.' : 'Are you sure you want to activate this distributor? They will gain access to the assigned features.'}
                    close={() => {
                        setDeleteDistributorModal(false);
                    }}
                    confirmDelete={_deleteDistributor} />

            }
        </Fragment>
    )
})

export default WhiteLabelSettingsDetail;